import mobileFilterTemplate from "./FilterMobile.hbs";

import { Initializer } from "modules/Initializer";
import { Select } from "components/Select/Select";

/**
 * @deprecated Use the new FilterGroup component instead.
 */
const filters = {
    init: () => {
        filters.renderMobileFilterButton();
        filters.customFilterToogle();
        filters.addEventListeners();
        filters.filterSearch();
    },
    get: (queryString: string) => {
        const searchParams = new URLSearchParams(queryString);
        const searchInput = document.querySelector("[js-filter-search]") as HTMLInputElement;

        let valuesArray: Array<string> = [];

        searchParams.forEach((val, key) => {
            if (key === "q") {
                searchInput.value = val;
            }
            else {
                valuesArray = val.split(",");
                let selectDropDown = document.querySelector<HTMLElement>(`[name="${key}"`);

                if (!selectDropDown) {
                    return;
                }

                const select = Initializer.getComponent<Select>(selectDropDown);

                if (!select) {
                    return;
                }

                selectDropDown = select.getRootElement();

                const selectToggle = selectDropDown.querySelector("[js-select-toggle]") as HTMLElement;
                let isMultiSelect = false;

                if (selectToggle !== null ) {
                    if (selectToggle.dataset.multiple === "true") {
                        isMultiSelect = true;
                    }

                    let itemsCount: number = 0;

                    if (selectDropDown) {
                        valuesArray.forEach((value) => {
                            const optionItem = document.querySelector(`[data-select-value="${value}"`);
                            if (optionItem) {
                                optionItem.classList.add("checked");

                                itemsCount++
                            }
                        });

                        select?.setLabels(itemsCount, isMultiSelect);
                    }
                }
            }
        });
    },
    set: () => {
        const selects = document.querySelectorAll(".js-select-component");
        const ranges = document.querySelectorAll<HTMLInputElement>("[js-range]");
        const searchInput = document.querySelector("[js-filter-search") as HTMLInputElement;
        const urlArray = [];
        const urlParams = new URLSearchParams;

        if (searchInput) {
            if (searchInput.value !== "") {
                urlArray.push({
                    "key": "q",
                    "value": searchInput.value
                })
            }
        }

        selects.forEach((select) => {
            const optionsArray: string[] = [];
            const name = select.getAttribute("name");
            const selectedOptions = select.querySelectorAll("[js-select-item].checked");

            if (selectedOptions.length > 0) {
                selectedOptions.forEach((selectedOption) => {
                    const item = selectedOption as HTMLElement;
                    const datX = item.dataset.selectValue;
                    if (datX)
                        optionsArray.push(datX);
                });

                urlArray.push({
                    "key": name,
                    "value": optionsArray
                });
            }
        });

        ranges.forEach((range: HTMLInputElement) => {
             
            const name = range.getAttribute("name");

             
            if (range.value !== "0") {
                urlArray.push({
                     
                    "key": name,
                     
                    "value": range.value
                });
            }       
        });      

        urlArray.forEach((entry) => {
            urlParams.set(entry.key, entry.value);
        });

        return urlParams;
    },
    renderMobileFilterButton: () => {
        const filtersContainer = document.querySelector("[js-filters]") as HTMLElement;
        const target = document.querySelector("main") as HTMLElement;
        const mobileButtonWrapperNode = document.createElement("div");
        let mobileButtonLabel: string = "";

        mobileButtonWrapperNode.classList.add("filter-mobile");
        mobileButtonWrapperNode.id = "filter-mobile";
        mobileButtonWrapperNode.setAttribute("js-mobile-filter", "");

        target.insertAdjacentElement("beforeend", mobileButtonWrapperNode);
        
        const targetElement = document.getElementById("filter-mobile");

        if (filtersContainer) {
            const txt = filtersContainer.dataset.labelFilterMobile;

            if (txt) {
                mobileButtonLabel = txt;
            }
            else {
                mobileButtonLabel = "Filter";
            }
        }
        if (targetElement) {
            targetElement.style.opacity = '0'
            targetElement.innerHTML = mobileFilterTemplate({ "label": mobileButtonLabel });
            window.addEventListener("scroll", () => {
                targetElement.style.opacity = window.scrollY > 10 ? "1" : "0";
            });
        }
    },
    customFilterToogle: () => {
        const customFilters: NodeListOf<HTMLElement> = document.querySelectorAll(".filter-custom .filter-header");

        customFilters.forEach((customFilter: HTMLElement) => {
            if (customFilter) {
                customFilter.addEventListener("click", (e: MouseEvent) => {
                    const filterCustomElement = (e.target as HTMLElement).closest(".filter-custom");
                    if (filterCustomElement) {
                        filterCustomElement.classList.toggle("active");
                    }
                });
            }
        });
    },
    addEventListeners: () => {
        const mobileFilterButton = document.getElementById("filter-mobile");
        const filtersContainer = document.querySelector(".filters");
        const mainContainer = document.getElementById("main-content");
        const mobileMinimizeFilters = document.getElementById("filters-collapse-mobile");
        const selectLists = document.querySelectorAll<HTMLDivElement>(".js-select-component");
        const ranges = document.querySelectorAll<HTMLInputElement>("[js-range]");
        const filterClearAll = document.getElementById("filter-clear");
        const filterClearAllMobile = document.getElementById("filter-clear-mobile");

        if (mobileFilterButton && filtersContainer && mainContainer) {
            mobileFilterButton.addEventListener("click", () => {
                filtersContainer.classList.add("active");
                mainContainer.classList.add("disabled");
            });
        }

        if (mobileMinimizeFilters && filtersContainer && mainContainer) {
            mobileMinimizeFilters.addEventListener("click", () => {
                filtersContainer.classList.remove("active");
                mainContainer.classList.remove("disabled");
            });
        }

        if (filtersContainer && mainContainer) {
            mainContainer.addEventListener("click", (e: Event) => {
                const target = e.target as HTMLElement;

                if (target) {
                    if (target.classList.contains("disabled")) {
                        mainContainer.classList.remove("disabled");
                        filtersContainer.classList.remove("active");
                    }
                }
            });
        }

        if (filterClearAll) {
            filterClearAll.addEventListener("click", (e: Event) => {
                const target = e.target as HTMLButtonElement;
                const customFilters: NodeListOf<HTMLElement> = document.querySelectorAll(".filter-custom");
                const selectLists = document.querySelectorAll<HTMLDivElement>(".js-select-component");

                if (target) {
                    if (selectLists.length > 0) {
                        selectLists.forEach((selectList) => {
                            const select = Initializer.getComponent<Select>(selectList);
                            select?.clearOptions();
                        });
                    }

                    if (ranges.length > 0) {
                        ranges.forEach((range: HTMLInputElement) => {
                             
                            range.value = "0";
                             
                            range.parentElement!.querySelector<HTMLElement>('.range-value')!.innerHTML = '0 km';
                        });
                    }

                    if (customFilters.length > 0) {
                        customFilters.forEach((customFilter: HTMLElement) => {
                            if (customFilter) {
                                customFilter.classList.remove("active");
                            }
                        });
                    }
                }
            });
        }

        if (filterClearAllMobile) {
            filterClearAllMobile.addEventListener("click", (e: Event) => {
                const target = e.target as HTMLButtonElement;
                const customFilters: NodeListOf<HTMLElement> = document.querySelectorAll(".filter-custom");

                if (target) {
                    if (selectLists.length > 0) {
                        selectLists.forEach((selectList) => {
                            const select = Initializer.getComponent<Select>(selectList);
                            select?.clearOptions();
                        });
                    }

                    if (ranges.length > 0) {
                        ranges.forEach((range: HTMLInputElement) => {
                             
                            range.value = "0";
                             
                            range.parentElement!.querySelector<HTMLElement>('.range-value')!.innerHTML = '0 km';
                        });
                    }

                    if (customFilters.length > 0) {
                        customFilters.forEach((customFilter: HTMLElement) => {
                            if (customFilter) {
                                customFilter.classList.remove("active");
                            }
                        });
                    }
                }
            });
        }
    },
    filterSearch: () => {
        const searchParams = new URLSearchParams(document.location.search);
        const searchFieldClear = document.querySelector("[js-filter-search-clear]") as HTMLDivElement;
        const searchQuery = searchParams.get("q");

        if (searchQuery) {
            if (searchFieldClear) {
                searchFieldClear.style.display = "flex";
            }
        }

        const filterSubmit = document.getElementById("filter-submit");
        const searchFieldInput = document.querySelector("[js-filter-search]") as HTMLInputElement;
        const searchFieldButton = document.querySelector("[js-filter-search-button]");

        //Filter submit
        if (filterSubmit) {

            filterSubmit.addEventListener("click", (e) => {
                e.preventDefault();

                const urlString: string = filters.set().toString();

                window.location.search = urlString;
            })
        }

        //Submit search on enter
        if (searchFieldInput) {
            searchFieldInput.addEventListener("keyup", (e) => {
                if (e.key === 'Enter') {
                    const urlString: string = filters.set().toString();

                    window.location.search = urlString;
                }
                else {
                    if (e.target) {
                        const input = e.target as HTMLInputElement;

                        if (input.value !== "") {
                            searchFieldClear.style.display = "flex";
                        }
                        else {
                            searchFieldClear.style.display = "none";
                        }
                    }
                }
            });
        }

        //Submit search in click
        if (searchFieldButton) {
            searchFieldButton.addEventListener("click", () => {
                const urlString: string = filters.set().toString();

                window.location.search = urlString;
            });
        }

        //Clear search
        if (searchFieldClear) {
            searchFieldClear.addEventListener("click", () => {
                searchFieldClear.style.display = "none";
                if (searchFieldInput) {
                    searchFieldInput.value = "";
                }
            })
        }
    }
}

export { filters }


